/**
 * Livewire Snapshot Error Handler
 * 
 * This script handles Livewire snapshot errors that occur when nested components
 * lose their state during parent component re-renders.
 */

document.addEventListener('DOMContentLoaded', function() {
    // Listen for Livewire errors
    window.addEventListener('livewire:exception', function(event) {
        const error = event.detail;
        
        // Check if it's a snapshot missing error
        if (error && error.message && error.message.includes('Snapshot missing')) {
            console.warn('Livewire snapshot error detected, attempting recovery...');
            
            // Extract component ID from error message
            const match = error.message.match(/id: ([A-Za-z0-9]+)/);
            if (match && match[1]) {
                const componentId = match[1];
                console.log('Component ID:', componentId);
                
                // Try to find and reload the component
                const componentElement = document.querySelector(`[wire\\:id="${componentId}"]`);
                if (componentElement) {
                    console.log('Found component element, reloading...');
                    
                    // Dispatch a custom event to notify parent component
                    window.dispatchEvent(new CustomEvent('livewire:component-error', {
                        detail: { componentId, element: componentElement }
                    }));
                }
            }
            
            // Prevent the error from breaking the page
            event.preventDefault();
        }
    });
    
    // Handle component errors
    window.addEventListener('livewire:component-error', function(event) {
        console.log('Handling component error:', event.detail);
        
        // Hide loading spinner if it's visible
        const loading = document.getElementById('loading');
        if (loading && !loading.classList.contains('hidden')) {
            loading.classList.add('hidden');
        }
        
        // Show a user-friendly notification
        if (window.Livewire) {
            window.dispatchEvent(new CustomEvent('notification', {
                detail: {
                    id: Date.now(),
                    type: 'warning',
                    message: 'Er is een fout opgetreden. Probeer het opnieuw.'
                }
            }));
        }
    });
});
